import React from 'react';
import styled from 'styled-components';
import { Popup, IPopupProps, FlexBox, Typography } from '@agilepoint/wat-react-ux';

interface ICustomPopupProps extends IPopupProps {
    headerTitle: string;
    width?: string;
    height?: string;
}

const StyledPopup = styled(Popup) <Omit<ICustomPopupProps, 'headerTitle'>>`    
    padding: 0px;
    color: ${({ theme: { semantics: { palette } } }) => palette.neutralPrimary};
    width: ${(props) => props.width};
    height: ${(props) => props.height};

    .ap-popup-header-wrapper {
        display: flex;
        background-color: ${({ theme: { mobileAppAccelerator: { semanticColors } } }) => semanticColors.grayVariant5};
    }

    .ap-popup-close-icon {
        position: unset;
    }

    .ap-popup-content {
        padding: 30px;
        box-sizing: border-box;
    }
    .ap-popup-footer {
        padding: 15px 30px 15px 0px;
        border-top: ${({ theme: { mobileAppAccelerator } }) => mobileAppAccelerator.semantics.popupFooterSeparator};
        box-sizing: border-box;
    }
`;

export const CustomPopup = React.memo((props: ICustomPopupProps) => {
    const { headerTitle, ...rest } = props;

    const renderTitle = React.useCallback(() => (
        <FlexBox justifyContent="center" alignItems="center" width="calc(100% - 40px)">
            <Typography.H6 title={headerTitle}>{headerTitle.toLocaleUpperCase()}</Typography.H6>
        </FlexBox>
    ), [headerTitle]);

    return (
        <StyledPopup
            {...rest}
            onRenderTitle={renderTitle} />
    );
});
